"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _file_input = _interopRequireDefault(require("../forms/file_input"));
var _papaparse = _interopRequireDefault(require("papaparse"));
var _fa = _interopRequireDefault(require("../util/fa"));
var _reactstrap = require("reactstrap");
var _reactSelectBoostrap = require("../autoform/reactSelectBoostrap4");
var _reactSelect = _interopRequireDefault(require("react-select"));
var _immutableSetter = require("immutable-setter");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _index = _interopRequireDefault(require("axios/index"));
var _loadingButton = _interopRequireDefault(require("../util/loadingButton"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var CSVUploadWidget = function CSVUploadWidget(_ref) {
  var onFileLoaded = _ref.onFileLoaded;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    loading = _useState2[0],
    setLoading = _useState2[1];
  var _useState3 = (0, _react.useState)(0),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    key = _useState4[0],
    setKey = _useState4[1];
  var handleChangeFile = function handleChangeFile(files) {
    setLoading(true);
    setKey(key + 1);
    var reader = new FileReader();
    var filename = files[0].name;
    reader.onload = function (event) {
      _papaparse["default"].parse(event.target.result, {
        worker: true,
        complete: function complete(results) {
          setLoading(false);
          if (results.errors.length > 0) {
            alert("Invalid CSV. Choose another file");
          } else {
            onFileLoaded(results.data, filename);
          }
        }
      });
    };
    reader.readAsText(files[0]);
  };
  return /*#__PURE__*/_react["default"].createElement(_file_input["default"], {
    key: "file-".concat(key),
    accept: ".csv, text/csv",
    files: [],
    onChange: handleChangeFile,
    disabled: loading
  }, loading && /*#__PURE__*/_react["default"].createElement(_fa["default"], {
    icon: "spinner",
    spin: true,
    className: "mr-2"
  }), "Select CSV File");
};
var CSVMappingWidget = function CSVMappingWidget(_ref2) {
  var rawData = _ref2.data,
    columns = _ref2.columns,
    onUpload = _ref2.onUpload,
    inputMappings = _ref2.mappings,
    _ref2$loading = _ref2.loading,
    loading = _ref2$loading === void 0 ? false : _ref2$loading;
  var _useState5 = (0, _react.useState)(inputMappings || {}),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    mappings = _useState6[0],
    setMappings = _useState6[1];
  rawData = _.filter(_.compact(rawData), function (row) {
    return _.compact(row).length > 0;
  });
  var _useState7 = (0, _react.useState)(rawData),
    _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
    data = _useState8[0],
    setData = _useState8[1];
  var handleOnClick = function handleOnClick() {
    if (_.keys(mappings).length < _.keys(columns).length) {
      return;
    }
    onUpload(_.map(_.slice(data, 1), function (row) {
      return _.mapValues(_.keyBy(_.map(mappings, function (value, key) {
        return {
          key: key,
          value: row[value]
        };
      }), 'key'), 'value');
    }));
  };
  var headers = _.filter(data[0], function (x) {
    return _.trim(x).length > 0;
  });
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_reactstrap.Table, {
    striped: true,
    style: {
      tableLayout: "fixed"
    }
  }, /*#__PURE__*/_react["default"].createElement("thead", null, /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("th", {
    style: {
      width: 60
    }
  }), _.map(columns, function (label, key) {
    return /*#__PURE__*/_react["default"].createElement("th", {
      className: "".concat(key),
      key: key
    }, label);
  })), _.isEmpty(inputMappings) && /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("th", {
    className: "pt-0"
  }, "#"), _.map(columns, function (label, key) {
    return /*#__PURE__*/_react["default"].createElement("th", {
      key: "header-".concat(key),
      className: "pt-0"
    }, /*#__PURE__*/_react["default"].createElement(_reactSelect["default"], {
      placeholder: "".concat(label, " Source..."),
      styles: _reactSelectBoostrap.styles,
      options: _.map(headers, function (header, index) {
        return {
          value: index,
          label: header
        };
      })
      // value={{value: mappings[key], label: key}}
      ,
      className: "react-select-container",
      classNamePrefix: "react-select",
      onChange: function onChange(value) {
        return setMappings((0, _immutableSetter.setIn)(mappings, [key], value.value));
      }
    }));
  }))), !_.isEmpty(mappings) && /*#__PURE__*/_react["default"].createElement("tbody", null, _.map(_.slice(data, 1), function (row, index) {
    return /*#__PURE__*/_react["default"].createElement("tr", {
      key: "row_".concat(index)
    }, /*#__PURE__*/_react["default"].createElement("td", null, /*#__PURE__*/_react["default"].createElement("strong", null, index + 1)), _.map(columns, function (label, key) {
      return /*#__PURE__*/_react["default"].createElement("td", {
        key: "column_".concat(key)
      }, _.includes(_.keys(mappings), key) && /*#__PURE__*/_react["default"].createElement(_reactstrap.Input, {
        value: row[mappings[key]],
        onChange: function onChange(e) {
          return setData((0, _immutableSetter.setIn)(data, [index + 1, mappings[key]], e.target.value));
        }
      }));
    }));
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-center mt-4"
  }, /*#__PURE__*/_react["default"].createElement(_loadingButton["default"], {
    loading: loading,
    color: "primary",
    className: "btn-wide",
    size: "lg",
    onClick: handleOnClick,
    disabled: loading || _.keys(mappings).length < _.keys(columns).length
  }, "Submit Data")));
};
var CSVUploader = exports["default"] = /*#__PURE__*/function (_Component) {
  function CSVUploader(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, CSVUploader);
    _this = _callSuper(this, CSVUploader, [props]);
    _this.onUpload = _this.onUpload.bind(_this);
    _this.state = {
      csvData: _this.props.data || null,
      loading: false
    };
    return _this;
  }
  (0, _inherits2["default"])(CSVUploader, _Component);
  return (0, _createClass2["default"])(CSVUploader, [{
    key: "onUpload",
    value: function onUpload(data) {
      var _this$props = this.props,
        axiosInstance = _this$props.axiosInstance,
        uploadUrl = _this$props.uploadUrl,
        onUpload = _this$props.onUpload;
      this.setState({
        loading: true
      });
      axiosInstance.put(uploadUrl, data).then(function (response) {
        onUpload(response);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, this.state.csvData === null ? /*#__PURE__*/_react["default"].createElement(CSVUploadWidget, {
        onFileLoaded: function onFileLoaded(data) {
          return _this2.setState({
            csvData: data
          });
        }
      }) : /*#__PURE__*/_react["default"].createElement(CSVMappingWidget, {
        mappings: this.props.mappings,
        data: this.state.csvData,
        columns: this.props.columns,
        onUpload: this.onUpload,
        loading: this.state.loading
      }));
    }
  }]);
}(_react.Component);
CSVUploader.propTypes = {
  axiosInstance: _propTypes["default"].func.isRequired,
  columns: _propTypes["default"].object.isRequired,
  uploadUrl: _propTypes["default"].string.isRequired,
  onUpload: _propTypes["default"].func.isRequired
};
CSVUploader.defaultProps = {
  axiosInstance: _index["default"]
};